<template>
  <div class="iconBase" @click="iconClick">
    <component
      :is="name"
      :width="width"
      :height="height"
      :color="color"
      :is-fill="isFill"
    />
  </div>
</template>

<script>
import HelpIcon from './HelpIcon'
import HomeIcon from './HomeIcon'
import LibraryIcon from './LibraryIcon'
import PointIcon from './PointIcon'
import PurchaseIcon from './PurchaseIcon'
import SearchIcon from './SearchIcon'
import AccountIcon from './AccountIcon'
import LogoutIcon from './LogoutIcon'
import SubscTypeIcon from './SubscTypeIcon'
import PrivilegeIcon from './PrivilegeIcon'
import SeeLaterIcon from './SeeLaterIcon'
import CloseIcon from './CloseIcon'

export default{
  name: 'iconBase',
  components:{
    HelpIcon,
    HomeIcon,
    LibraryIcon,
    PointIcon,
    PurchaseIcon,
    SearchIcon,
    AccountIcon,
    LogoutIcon,
    SubscTypeIcon,
    PrivilegeIcon,
    SeeLaterIcon,
    CloseIcon
  },
  props: {
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    width: {
      type: [String, Number],
      default: '20'
    },
    height: {
      type: [String, Number],
      default: '20'
    },
    isFill: {
      type: Boolean,
      default: false
    },
    isButton:{
      type: Boolean,
      default: true
    }
  },
  methods:{
    iconClick(){
      if(this.isButton) this.$emit('clicked')
    }
  }
}</script>

<style lang="scss" scoped>
.iconBase{
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/icon/IconBase.vue